import { createFileRoute } from "@tanstack/react-router"
import { projectFormSubmissionDetailViewStaticData } from "src/views/ProjectFormSubmissionDetailView/constants"
import { ProjectFormSubmissionDetailView } from "src/views/ProjectFormSubmissionDetailView/ProjectFormSubmissionDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/",
)({
	component: ProjectFormSubmissionDetailView,
	staticData: projectFormSubmissionDetailViewStaticData,
})
